import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import slugify from "slugify";
import { Helmet } from "react-helmet";
import CarInfoBox from "../Cars/CarInfoBox";
import '../../styles/ShopByBrands.css'; 

const Suppliers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const locale = localStorage.getItem('lang');
  const { gdcURL, PCID, apiB2BURL, token } = useContext(ConfigContext);
  const dir = localStorage.getItem('dir');
  const [suppliers, setSuppliers] = useState([]);
  const [ResponseData, setResponseData] = useState([]);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [alphabet, setAlphabet] = useState('A');

  const sectionRefs = useRef({});

  const handleScrollToSection = (id) => {
    if (sectionRefs.current[id]) {
      sectionRefs.current[id].scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleTooltip = (supId, event) => {
    event.preventDefault();
    setActiveTooltip(activeTooltip === supId ? null : supId);
  };

  useEffect(() => {
    window.scrollTo(0, 0)
    const business_id = localStorage.getItem("business_id");
    const business_user_id = localStorage.getItem("business_user_id");
    var config = {
      method: 'get',
      url: `${apiB2BURL}/Customer/Dashboard/GetSupplierBrands?status=1&popular=1&lang=en&pc_id=${localStorage.getItem('pc_id')}`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'token': token,
        'businessid': business_id,
        'businessuserid': business_user_id
      }
    };
    axios(config)
      .then(function (response) {
        setResponseData(response.data.data);
        setSuppliers(response.data.data);
        // response.data.data.sort((a, b) => a.SUP_BRAND.localeCompare(b.SUP_BRAND));

        // // Initialize a Map to hold the categorized data
        // const map = new Map();
        // map.set("09", []);

        // // Group data by the initial letter of SUP_BRAND
        // response.data.data.forEach(item => {
        //     const initial = item.SUP_BRAND[0].toUpperCase();
        //     if (/\d/.test(initial)) {
        //         map.get("09").push(item);
        //     } else {
        //         if (!map.has(initial)) {
        //             map.set(initial, []);
        //         }
        //         map.get(initial).push(item);
        //     }
        // });

        // // Convert the Map to an array, sort by keys, and update state
        // const sortedEntries = new Map([...map.entries()].sort());

        // setSuppliers(sortedEntries);


      })
      .catch(function (error) {
      });

  }, [])

  useEffect(() => {
    if (suppliers.length > 0) {
      // Get all unique alphabets and sort them
      const uniqueAlphabets = [...new Set(suppliers.map(supplier => supplier.alphabet))].sort();
      // Set the first alphabet as default
      if (uniqueAlphabets.length > 0) {
        setAlphabet(uniqueAlphabets[0]);
      }
    }
  }, [suppliers]); // This will run whenever suppliers array changes


  return (
    <main className="main" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : '' }}>
      <Helmet>
        <title>Spare Parts Suppliers - {t('site_name')}</title>
        <meta name="description" content={`Find the best spare parts suppliers at {t('site_name')}. We offer a wide range of high-quality parts to meet your needs.`} />

        <meta name="keywords" content={ResponseData && ResponseData.map((item) => { return item.SUP_BRAND; })} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={`Spare Parts Suppliers - ${t('site_name')}`} />
        <meta property="og:description" content={`Explore the top-rated spare parts suppliers at ${t('site_name')}. Discover a variety of parts and components for different industries.`} />
        <meta property="og:url" content={`${t('site_url')}/spare-parts-suppliers`} />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`Spare Parts Suppliers - ${t('site_name')}`} />
        <meta name="twitter:description" content={`Looking for spare parts suppliers? ${t('site_name')} connects you with the best suppliers offering quality parts and services.`} />

        <link rel="canonical" href={`${t('site_url')}/spare-parts-suppliers`} />
      </Helmet>

      <div className="container">
        <div className="container">
          <nav aria-label="breadcrumb" className="breadcrumb-nav">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><NavLink to={'/'}><i className="icon-home" /></NavLink></li>
              <li className="breadcrumb-item"><NavLink to={() => { }}>{t('home')}</NavLink></li>
              <li className="breadcrumb-item active" aria-current="page"></li>
            </ol>
          </nav>
        </div>
        <div className="container">
          <CarInfoBox isHorizontal={true} redirectStatus={true} />
          <br />
          <h3>{t('catalogue_of_manufacturers')}</h3>
          <span>{t('our_shop_offer_catalogue', { value: suppliers.length })}</span>
          <div className="col-lg-12">

            {
              suppliers && <div style={{
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                WebkitOverflowScrolling: 'touch',
                scrollbarWidth: 'thin',
                msOverflowStyle: 'none',
                padding: '10px 0'
              }}>
                {
                  [...new Set(suppliers.map(supplier => supplier.alphabet))].sort().map((letter) => (
                    <div
                      className="col-auto"
                      key={letter}
                      onClick={() => setAlphabet(letter)}
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        margin: '5px',
                        backgroundColor: alphabet === letter ? '#cc000b' : '#f8f9fa',
                        color: alphabet === letter ? '#fff' : '#000',
                        borderRadius: '5px',
                        display: 'inline-block'
                      }}
                    >
                      <h5 style={{ margin: 0 }}>{letter}</h5>
                    </div>
                  ))
                }
              </div>
            }
          </div>
        </div>


        <div className="container">
          {
            suppliers && <div >

              <div className="col-lg-12" >

                <hr style={{ margin: '8px' }} />
                {/* <h3 style={{color: '#cc000b', margin: 0, paddingLeft: '10px'}}>{key}</h3> */}

                <div className="row justify-content-center">
                  {suppliers.filter((c) => c.alphabet === alphabet).map((sup, index) => {
                    return (
                      <NavLink key={`supplier-logos-${index}`} to={`/Spare-Parts/PartsByBrand/${sup.SUP_BRAND}`}>
                        <div className="brand-card" style={{
                          margin: '5px',
                          // border: '1px solid #CCC', 
                          height: '150px',
                          width: '150px',
                          display: 'flex',
                          flexDirection: 'column', // Added to stack items vertically
                          justifyContent: 'center',
                          alignItems: 'center',
                          position: 'relative'
                        }}>
                          <div style={{
                            position: 'absolute',
                            top: '0',
                            right: '0',
                            height: '20px',
                            backgroundColor: '#cc010c',
                            color: '#FFF',
                            padding: '5px 10px',
                            fontSize: '10px',
                            fontWeight: 'bold',
                            zIndex: 2,
                            display: 'flex',
                            alignItems: 'center',
                            borderRadius: '0 0 0 8px'
                          }}>{sup.business_brand_discount}% OFF</div>
                          <ImageWithFallback src={`${gdcURL}/sup-logo/${sup.SUP_LOGO_NAME}`} alt={sup.SUP_BRAND} index={index} fallbackText={sup.SUP_BRAND} />

                          {/* <NavLink to={`/Spare-Parts/PartsByBrand/${sup.SUP_BRAND}`} style={{ marginTop: '5px' }}>Buy Now</NavLink>  */}
                        </div>
                      </NavLink>
                    )
                  })}
                </div>
              </div>

            </div>
          }
        </div>
      </div>
    </main>
  )
}
const ImageWithFallback = ({ src, index, alt, fallbackText }) => {
  const [imgError, setImgError] = useState(false);

  const handleError = () => {
    setImgError(true);
  };
  const fallbackStyle = {
    textAlign: 'center',
    fontSize: '8px',
    padding: '10px',
    wordBreak: 'break-word',
    maxWidth: '90%',

  };

  const containerStyle = {
    position: 'relative',
    width: '100px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '0px solid #CCC',
    padding: '11px'
  };
  return (
    <div style={containerStyle}>
      {imgError ? (
        <div style={fallbackStyle}>{fallbackText}</div>
      ) : (
        <img style={{ height: '45px', float: 'none' }} key={`img-part-${index}`} src={src} alt={alt} onError={handleError} />

      )}
    </div>
  );
};
export default Suppliers;